import "./styles/main.scss";
import Header from "Dashboard/components/Header";
import Toolbox from "./scenes/Main/components/Toolbox";
import TopSection from "./scenes/Main/components/TopSection";
import BottomSection from "./scenes/Expenses/components/BottomSection";

const Expenses = () => {
  return (
    <>
      <Header title="Troškovi" />
      <Toolbox />
      <main id="expenses">
        <TopSection />
        <BottomSection />
      </main>
    </>
  );
};

export default Expenses;
